'use strict';

var ResourceFactory = require('../Factory');
var Validate = require('../../core').Validate;

var definition = {
  name: 'Annotation',
  basePath: ':basePath',
  endpoint: 'annotations',
  debug: false,
  relations: {
    hasMany: {
      AnnotationLayer: {
        localField: 'annotationLayers',
        foreignKey: 'annotationId'
      }
    },
    belongsTo: {
      Site : {
        localField: 'site',
        localKey: 'siteId'
      }
    }
  },
  methods: null
};

var AnnotationResource = function(DS) {
  var resourceFactory = new ResourceFactory(DS);

  this.initialize = function (options) {
    var resourceOptions = getResourceOptions(options);
    return resourceFactory.createResource(resourceOptions);
  };
};

function getResourceOptions (options) {

  Validate.exists(options, 'fbBaseUri');
  Validate.exists(options, 'fbAuthToken');

  return {
    name : 'Annotation',
    apiBaseUri: options.apiBaseUri,
    collectionMethods: {},

    // definition to be formatted and passed to js-data DS
    definition: {
      format: definition,
      params: {
        basePath: options.apiBaseUri
      }
    },

    // group: true,

    // hooks to be passed to js-data DS
    hooks: {},

    // model methods to be passed to js-data DS and attached to every model
    modelMethods: {},

    // sync trigger definitions
    // the model trigger definitions will be initiliazed and attached to every collection model
    syncTriggers: {
      // collection: [{
      //   type: 'firebase',
      //   basePath: options.fbBaseUri,
      //   endpoint: 'annotations/sites/:siteId/public/lastUpdated',
      //   token: options.fbAuthToken
      // }],

      // // when the sync listeners are attached, any `:modelId` placeholder will be replaced
      // // automatically with the actual id of the model the listener is being initialized for
      // model: [{
      //   type: 'firebase',
      //   basePath: options.fbBaseUri,
      //   endpoint: 'annotations/items/:modelId/lastUpdated',
      //   token: options.fbAuthToken
      // }, {
      //   type: 'firebase',
      //   basePath: options.fbBaseUri,
      //   endpoint: 'annotations/items/:modelId/layers/lastUpdated',
      //   token: options.fbAuthToken
      // }]
    }
  };
}

module.exports = AnnotationResource;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/annotation/AnnotationResource.js